/* eslint-disable react-native/no-inline-styles */
import React from "react";
import { ScrollView, StyleSheet } from "react-native";
import { Button, Paragraph, useTheme, Menu, IconButton, Divider } from "react-native-paper";
import { Block } from "@block";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { useTranslation } from "react-i18next";
import { useDesktopMediaQuery } from "@media-query";
import { spacing } from "@styles/spacing";
import { StackSpacing } from "@components/spacing";
import { RegisterOptions, useForm } from "react-hook-form";
import { InputSelect, InputText } from "app/shared/components/form/input";
import { QueueSpacing } from "@components/spacing";
import { StackActions, useNavigation } from "@react-navigation/core";
import { useRoute } from "@react-navigation/native";
import { RouteProp } from "@react-navigation/native";
import StackParamsList from "../../../../navigation/nav-stack-params";
import ScreenNameType from "@navigation/nav-screens";
import moment from "moment";
import { formatCurrency } from "app/shared/util/format-currency";
import { useDispatch, useSelector } from "react-redux";
import { ACCOUNT } from "app/shared/services/services-model.type";
import AccountSourceModal from "app/shared/components/modal/bene-account-source/accounts-source.modal";
import { Constant } from "app/shared/constant/constant";
import { globalShowFuture } from "app/shared/util/future";
import GlobalModal, { createGlobalModal, globalModal } from "app/shared/components/modal/global-modal/global-modal";
import { formatFdTerm, getIntRate, getTermDepositProductName } from "app/modules/term-deposit/term-deposit-utils/term-deposit.utils";
import { getAccountStatus } from "app/shared/util/common";
import { getAccountProfileSelector } from "../../reducer/selectors";
import { fetchAccountDetailRequest } from "../../reducer/actions";
import { setTermTopUpReset } from "app/modules/term-deposit/term-deposit-top-up/reducer/actions";
import { setTermStatementReset } from "app/modules/term-deposit/term-deposit-statement/reducer/actions";

enum FormEnum {
  accountNo,
}

type ValidDataSchemeFormData = {
  [key in keyof typeof FormEnum]: Omit<RegisterOptions, "valueAsNumber" | "valueAsDate" | "setValueAs">;
};

interface DetailAccountRollData {
  accountSource: string; // TK chọn
  accountNo: string; // Số tk
  accountName: string; // Tên TK
  currentBalance: string; // số dư hiện tại
  availableBalance: string; // Số dư khả dụng
  accountTypeName: string; // loại tk

  // tk thanh toán
  holdAmount: string; // Số dư phong toả
  lastTransDate: string; // Ngày giao dịch cuối cùng
  intRateADV: string; // Lãi suất trung bình (lãi suất thấu chi)

  // tk tiết kiệm
  ib: string; // Hình thức mở tk tiết kiệm
  depAmt: string; // Số dư gốc
  nxtIntDt: string; // Ngày lãnh lãi kế tiếp

  // tk vay
  contNo: string; // số hợp đồng tk vay
  lnAmount: string; // Gốc trong hạn tk vay
  lnTerm: string; // Kỳ hạn vay
  nIntDat: string; // Ngày trả lãi kế tiếp

  // Chung
  branchName: string; // Chi nhánh quản lý sổ
  openDate: string; // Ngày mở tk
  intRate: string; // Lãi suất
  intRateOd: string; // Lãi suất trong ngày/ Hạn mức thấu chi
  intAmt: string; // Số tiền lãi nhận được
  accountInt: string; // Lãi cộng dồn
  productName: string; // sản phẩm
  fdTerm: string; // Kỳ hạn
  effDate: string; // ngày hiệu lực
  matDate: string; // Ngày đến hạn
  status: string;
}

type ProfileScreenRouteProp = RouteProp<StackParamsList, ScreenNameType.DETAIL_ACCOUNT_ROLL>;

const DetailAccountRoll = () => {
  const { fonts, colors } = useTheme();
  const { t } = useTranslation();
  const { dispatch } = useNavigation();
  const dispatchStore = useDispatch();

  const {
    params: { account },
  } = useRoute<ProfileScreenRouteProp>();

  const isDesktop = useDesktopMediaQuery();
  const { control, setValue, getValues, reset } = useForm<DetailAccountRollData>({
    defaultValues: {
      accountNo: "",
      accountSource: "",
      accountName: "",
      currentBalance: "",
      availableBalance: "",
      accountTypeName: "",
      openDate: "",
    },
    mode: "onChange",
  });

  const validateSchemeForm: ValidDataSchemeFormData = {
    accountNo: {
      required: {
        value: false,
        message: "",
      },
    },
  };

  const accountDetailStore = useSelector(getAccountProfileSelector);

  const [globalModalRef] = React.useState<React.RefObject<any>>(createGlobalModal());
  const [accountSelect, setAccountSelect] = React.useState<ACCOUNT>({ ...account } || {});
  const [visible, setVisible] = React.useState(false);

  const textInputProps: object = {
    editable: false,
  };
  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        dispatch(StackActions.replace(ScreenNameType.HOME));
      },
    },
    {
      name: t("ACC_QUAN_LY_TAI_KHOAN"),
      onPressSubtitle: () => {
        dispatch(StackActions.replace(ScreenNameType.LIST_ACCOUNT_MANAGEMENT));
      },
    },
    {
      name: t("ACC_DANH_SACH_TAI_KHOAN"),
      onPressSubtitle: () => {
        dispatch(StackActions.replace(ScreenNameType.ACCOUNT_ROLL));
      },
    },
    {
      name: t("ACC_CHI_TIET_TAI_KHOAN"),
      onPressSubtitle: () => {},
    },
  ];

  const accountPayment = (type: string) => type === Constant.ACCOUNTTYPE.ACCOUNT_PAYMENT;
  const accountDeposit = (type: string) => Constant.ACCOUNTTYPE.ACCOUNT_TERM_DEPOSIT.includes(type);
  const accountLoan = (type: string) => type === Constant.ACCOUNTTYPE.ACCOUNT_LOAN;

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        container: { flex: 1 },
        fieldFromText: {
          color: colors.text,
          width: 200,
          fontWeight: "700",
          fontSize: 16,
        },
        textInput: {},
        buttonContainer: { alignSelf: "center", backgroundColor: colors.primary },
        acceptButtonContainer: { alignSelf: "center", backgroundColor: colors.accent },
        textBlack: { color: colors.text },
        textWhite: { color: colors.surface },
        buttonsStyles: { flex: 1, alignSelf: "center", borderRadius: 24, backgroundColor: colors.primary, maxWidth: 200 },
        menuStyle: { borderRadius: spacing.small },
      }),
    [colors],
  );

  const getOpenTermType = React.useCallback(
    (ib?: string) => {
      if (ib === "Y") return t("ACC_MO_ONLINE");
      return t("ACC_MO_TAI_QUAY");
    },
    [t],
  );

  const mapDataDefault = React.useCallback(
    (data: ACCOUNT) => {
      setValue("accountSource", String(data.ACCOUNTNO));
      setValue("accountNo", String(data.ACCOUNTNO));
      setValue("accountName", String(data.ACCOUNTNAME));
      setValue("accountTypeName", String(data.ACCOUNTTYPENAME));
      setValue("currentBalance", String(formatCurrency(data.CURRENTBALANCE, data.CURRENCYCODE)));
      setValue("branchName", String(data.BRANCH_NAME));
      setValue("status", getAccountStatus(String(data.STATUS)));
      if (accountDeposit(data.ACCOUNTTYPE || "")) setValue("ib", getOpenTermType(data?.IB));
    },
    [getOpenTermType, setValue],
  );

  const mapDataDetail = React.useCallback(
    (data: ACCOUNT) => {
      setValue("intRate", String(getIntRate(data.INTRATE) + " % / " + t("COMMON_NAM").toLowerCase()));
      setValue("openDate", moment(String(data.OPENDATE)).format("DD/MM/YYYY").toString());
      if (data.LASTTRANSDATE?.length) {
        setValue("lastTransDate", moment(String(data.LASTTRANSDATE)).format("DD/MM/YYYY").toString());
      } else {
        setValue("lastTransDate", t("ACC_CHUA_CO_GD_PHAT_SINH"));
      }
      // Tài khoản thanh toán
      if (accountPayment(data.ACCOUNTTYPE || "")) {
        setValue("availableBalance", String(formatCurrency(data.AVAILABLEBALANCE, data.CURRENCYCODE)));
        setValue("intRateOd", String(formatCurrency(data.INTRATEOD, data.CURRENCYCODE)));
        setValue("intRateADV", String(getIntRate(data.INTRATEADV) + " % / " + t("COMMON_NAM").toLowerCase()));
        setValue("holdAmount", String(formatCurrency(data.HOLDAMOUNT, data.CURRENCYCODE)));
        setValue("intAmt", String(formatCurrency(data.INTAMT, data.CURRENCYCODE)));
        setValue("accountInt", String(formatCurrency(data.ACCOUNTINT, data.CURRENCYCODE)));
      } else if (accountDeposit(data.ACCOUNTTYPE || "")) {
        // Tài khoản tiết kiệm
        setValue("productName", getTermDepositProductName(data.PRODUCTCODE));
        setValue("fdTerm", formatFdTerm(data.FDTERM));
        setValue("effDate", moment(String(data.EFFDATE)).format("DD/MM/YYYY").toString());
        setValue("matDate", moment(String(data.MATDATE)).format("DD/MM/YYYY").toString());
        setValue("depAmt", String(formatCurrency(data.DEPAMT, data.CURRENCYCODE)));
        setValue("intAmt", String(formatCurrency(data.INTAMT, data.CURRENCYCODE)));
        setValue("accountInt", String(formatCurrency(data.ACCOUNTINT, data.CURRENCYCODE)));
        setValue("nxtIntDt", moment(String(data.NXTINTDT)).format("DD/MM/YYYY").toString());
      } else if (accountLoan(data.ACCOUNTTYPE || "")) {
        // Tài khoản vay
        setValue("contNo", String(data.CONTNO));
        setValue("productName", String(data.PRODUCTCODE));
        setValue("effDate", moment(String(data.EFFDATE)).format("DD/MM/YYYY").toString());
        setValue("matDate", moment(String(data.MATDATE)).format("DD/MM/YYYY").toString());
        setValue("lnTerm", formatFdTerm(data.LNTERM));
        setValue("lnAmount", String(formatCurrency(data.LNAMOUNT, data.CURRENCYCODE)));
        setValue("nIntDat", moment(String(data.NINTDAT)).format("DD/MM/YYYY").toString());
      }
    },
    [setValue, t],
  );

  const handlerRequestDetail = React.useCallback(
    (accountNo?: string, accountType?: string) => {
      if (accountNo && accountType) {
        dispatchStore(fetchAccountDetailRequest({ ACCOUNTNO: accountNo, ACCOUNTTYPE: accountType }));
      }
    },
    [dispatchStore],
  );

  const openMenu = () => setVisible(true);

  const closeMenu = () => setVisible(false);

  const onChangeSelectAccount = (item: ACCOUNT) => {
    globalModal.hide(globalModalRef);
    reset();
    setAccountSelect(item);
  };

  const onPressChoose = () => {
    const content: JSX.Element = <AccountSourceModal title={t("ACC_CHON_TAI_KHOAN")} onPressAcceptAccount={onChangeSelectAccount} />;
    globalModal.show(content, globalModalRef);
  };

  const onPressStatement = () => {
    closeMenu();
    dispatch(StackActions.replace(ScreenNameType.LIST_STATEMENT, { account: accountDetailStore }));
  };

  const onPressLoanPayment = () => {
    closeMenu();
    globalShowFuture();
  };

  const onPressDepositPawned = () => {
    // Sổ tiết kiệm cầm cố
    closeMenu();
    globalShowFuture();
  };

  const onPressDepositTopUp = () => {
    // Sổ tiết kiệm nộp thêm
    closeMenu();
    dispatchStore(setTermTopUpReset());
    dispatch(StackActions.replace(ScreenNameType.TERM_DEPOSIT_TOP_UP_CREATE, { account: accountDetailStore, resetData: true }));
  };

  const onPressDepositClose = () => {
    // Sổ tiết kiệm tất toán
    closeMenu();
    dispatchStore(setTermStatementReset());
    dispatch(StackActions.replace(ScreenNameType.TERM_DEPOSIT_STATEMENT_CREATE, { account: accountDetailStore, resetData: true }));
  };

  const getListMenu = () => {
    const list: Array<{ label: string; action: () => void }> = [];
    if (accountPayment(accountDetailStore?.ACCOUNTTYPE || "")) {
      list.push({ label: t("ACC_XEM_SAO_KE"), action: () => onPressStatement() });
    }
    if (accountLoan(accountDetailStore?.ACCOUNTTYPE || "")) {
      list.push({ label: t("ACC_MAN_LICH_SU_TRA_NO"), action: () => onPressLoanPayment() });
    }
    if (accountDeposit(accountDetailStore?.ACCOUNTTYPE || "") && accountDetailStore?.STATUS === "P") {
      list.push({ label: t("ACC_MAN_THONG_TIN_KHOAN_VAY"), action: () => onPressDepositPawned() });
    }
    if (accountDeposit(accountDetailStore?.ACCOUNTTYPE || "") && accountDetailStore?.DPSTALW === "Y") {
      list.push({ label: t("SAVING_NOP_THEM"), action: () => onPressDepositTopUp() });
    }
    if (
      accountDeposit(accountDetailStore?.ACCOUNTTYPE || "") &&
      (accountDetailStore?.WDRLALW === "Y" || accountDetailStore?.CLOSEALW === "Y" || accountDetailStore?.DPSTALW === "Y")
    ) {
      list.push({ label: t("SAVING_TAT_TOAN"), action: () => onPressDepositClose() });
    }
    return list;
  };

  const FieldForm = () => {
    const listMenu = getListMenu();
    return (
      <Block row={!isDesktop} center>
        <StackSpacing size="medium" />
        <Paragraph style={styles.fieldFromText}>{t("ACC_QUAN_LY_TAI_KHOAN")}</Paragraph>
        <StackSpacing size="medium" />
        <>
          {!isDesktop && listMenu.length > 0 && (
            <Block flex={1} right absRight={spacing.micro}>
              <Menu
                contentStyle={styles.menuStyle}
                visible={visible}
                onDismiss={closeMenu}
                anchor={<IconButton onPress={openMenu} icon="menu-open" size={24} />}>
                {listMenu.map((item, index) => {
                  return (
                    <Block key={index}>
                      <Menu.Item titleStyle={{ ...fonts.medium }} onPress={item.action} title={item.label} />
                      <Divider style={{ display: index !== listMenu.length - 1 ? "flex" : "none" }} />
                    </Block>
                  );
                })}
              </Menu>
            </Block>
          )}
        </>
      </Block>
    );
  };

  const FormButtonAction = () => {
    const listMenu = getListMenu();
    return isDesktop ? (
      <Block flex={1} ml={spacing.large}>
        {listMenu.length > 0 ? (
          listMenu.map((item, index) => {
            return (
              <Block key={index} flex={1} center row middle mb={spacing.medium}>
                <Button
                  uppercase={false}
                  labelStyle={styles.textBlack}
                  mode="contained"
                  style={styles.buttonsStyles}
                  color={colors.primary}
                  onPress={() => item.action()}>
                  {item.label}
                </Button>
              </Block>
            );
          })
        ) : (
          <Block />
        )}
      </Block>
    ) : (
      <Block />
    );
  };

  const FormSelectAccount = (
    <Block row={isDesktop} center={isDesktop} flex={1} bg={colors.backgroundForm} br={12} p={spacing.medium}>
      <Block flex={1}>
        <InputSelect
          control={control}
          name="accountNo"
          label={t("ACC_TAI_KHOAN")}
          rules={validateSchemeForm.accountNo}
          style={styles.textInput}
          onClick={onPressChoose}
        />
      </Block>
      {FormButtonAction()}
    </Block>
  );

  const FormInLine = (left: { name: string; label: string }, right: { name: string; label: string }) => (
    <Block row={isDesktop ? true : false}>
      <Block flex={isDesktop ? 1 : undefined}>
        <InputText name={left.name} control={control} style={styles.textInput} inputProps={textInputProps} label={left.label} />
      </Block>
      <QueueSpacing size={"huge"} />
      <Block flex={isDesktop ? 1 : undefined}>
        <InputText name={right.name} control={control} style={styles.textInput} inputProps={textInputProps} label={right.label} />
      </Block>
    </Block>
  );

  const FormContentPayment = (
    <Block flex={1}>
      {FormInLine({ name: "accountNo", label: t("ACC_SO_TAI_KHOAN") }, { name: "accountName", label: t("ACC_TEN_TAI_KHOAN") })}
      {FormInLine({ name: "currentBalance", label: t("ACC_SO_DU_HIEN_TAI") }, { name: "accountTypeName", label: t("ACC_LOAI_TAI_KHOAN") })}
      {FormInLine({ name: "availableBalance", label: t("ACC_SO_DU_KHA_DUNG") }, { name: "branchName", label: t("ACC_CHI_NHANH") })}
      {FormInLine({ name: "openDate", label: t("ACC_NGAY_MO_TAI_KHOAN") }, { name: "intRate", label: t("ACC_LAI_SUAT") })}
      {FormInLine({ name: "lastTransDate", label: t("ACC_GIAO_DICH_GAN_NHAT") }, { name: "holdAmount", label: t("ACC_SO_TIEN_PHONG_TOA") })}
      {FormInLine({ name: "intRateOd", label: t("ACC_HAN_MUC_THAU_CHI") }, { name: "intRateADV", label: t("ACC_LAI_THAU_CHI") })}
      {FormInLine({ name: "intAmt", label: t("ACC_SO_LAI_NHAN_DUOC") }, { name: "accountInt", label: t("ACC_LAI_CONG_DON") })}
      <Block row={isDesktop ? true : false}>
        <Block flex={isDesktop ? 1 : undefined}>
          <InputText name="status" control={control} style={styles.textInput} inputProps={textInputProps} label={t("ACC_TRANG_THAI")} />
        </Block>
        <QueueSpacing size={"huge"} />
        <Block flex={isDesktop ? 1 : undefined} />
      </Block>
    </Block>
  );

  const FormContentDeposit = (
    <Block flex={1}>
      {FormInLine({ name: "accountNo", label: t("ACC_SO_TAI_KHOAN") }, { name: "accountName", label: t("ACC_TEN_TAI_KHOAN") })}
      {FormInLine({ name: "currentBalance", label: t("ACC_SO_DU_SO") }, { name: "accountTypeName", label: t("ACC_LOAI_TAI_KHOAN") })}
      {FormInLine({ name: "productName", label: t("ACC_SAN_PHAM") }, { name: "fdTerm", label: t("ACC_KY_HAN") })}
      {FormInLine({ name: "depAmt", label: t("ACC_SO_DU_GOC") }, { name: "intRate", label: t("ACC_LAI_SUAT") })}
      {FormInLine({ name: "effDate", label: t("ACC_NGAY_HIEU_LUC") }, { name: "matDate", label: t("ACC_NGAY_DEN_HAN") })}
      {FormInLine({ name: "intAmt", label: t("ACC_SO_LAI_NHAN_DUOC") }, { name: "nxtIntDt", label: t("ACC_NGAY_NHAN_LAI_KE_TIEP") })}
      {FormInLine({ name: "ib", label: t("ACC_HINH_THUC_MO_SO") }, { name: "branchName", label: t("ACC_CHI_NHANH_QL_SO") })}
      <Block row={isDesktop ? true : false}>
        <Block flex={isDesktop ? 1 : undefined}>
          <InputText name="status" control={control} style={styles.textInput} inputProps={textInputProps} label={t("ACC_TRANG_THAI")} />
        </Block>
        <QueueSpacing size={"huge"} />
        <Block flex={isDesktop ? 1 : undefined} />
      </Block>
    </Block>
  );

  const FormContentLoan = (
    <Block flex={1}>
      {FormInLine({ name: "accountNo", label: t("ACC_SO_TAI_KHOAN") }, { name: "accountName", label: t("ACC_TEN_TAI_KHOAN") })}
      {FormInLine(
        { name: "currentBalance", label: t("ACC_MAN_DU_NO_HIEN_TAI") },
        { name: "accountTypeName", label: t("ACC_LOAI_TAI_KHOAN") },
      )}
      {FormInLine({ name: "contNo", label: t("ACC_SO_HOP_DONG") }, { name: "productName", label: t("ACC_SAN_PHAM") })}
      {FormInLine({ name: "lnTerm", label: t("ACC_KY_HAN") }, { name: "intRate", label: t("ACC_LAI_SUAT") })}
      {FormInLine({ name: "lastTransDate", label: t("ACC_GIAO_DICH_GAN_NHAT") }, { name: "lnAmount", label: t("ACC_GOC_TRONG_HAN") })}
      {FormInLine({ name: "effDate", label: t("ACC_NGAY_HIEU_LUC") }, { name: "matDate", label: t("ACC_NGAY_DEN_HAN") })}
      {FormInLine({ name: "nIntDat", label: t("ACC_NGAY_TRA_LAI_KE_TIEP") }, { name: "branchName", label: t("ACC_CHI_NHANH") })}
      <Block row={isDesktop ? true : false}>
        <Block flex={isDesktop ? 1 : undefined}>
          <InputText name="status" control={control} style={styles.textInput} inputProps={textInputProps} label={t("ACC_TRANG_THAI")} />
        </Block>
        <QueueSpacing size={"huge"} />
        <Block flex={isDesktop ? 1 : undefined} />
      </Block>
    </Block>
  );

  const FormContent = () => {
    const isPaymemt = accountPayment(accountSelect.ACCOUNTTYPE || "");
    const isDeposit = accountDeposit(accountSelect.ACCOUNTTYPE || "");
    const isLoan = accountLoan(accountSelect.ACCOUNTTYPE || "");
    return (
      <>
        {isPaymemt ? FormContentPayment : null}
        {isDeposit ? FormContentDeposit : null}
        {isLoan ? FormContentLoan : null}
      </>
    );
  };

  const FormDetail = (
    <Block minHeight={300} flex={1} bg={colors.backgroundForm} br={12}>
      <Block pv={spacing.medium} flex={1} ph={spacing.medium}>
        <FormContent />
      </Block>
    </Block>
  );

  const ButtonForm = (
    <Block row middle pv={spacing.huge}>
      <Block w={isDesktop ? 200 : 0} />
      <Button onPress={() => dispatch(StackActions.pop())} mode="contained" style={styles.buttonContainer}>
        {t("COMMON_QUAY_LAI")}
      </Button>
      <QueueSpacing size="large" />
      <Button
        labelStyle={styles.textWhite}
        mode="contained"
        style={styles.acceptButtonContainer}
        onPress={() => dispatch(StackActions.replace(ScreenNameType.HOME))}>
        {t("FUNC_TRANG_CHU")}
      </Button>
    </Block>
  );

  React.useEffect(() => {
    if (accountSelect) {
      mapDataDefault(accountSelect);
      handlerRequestDetail(accountSelect.ACCOUNTNO, accountSelect.ACCOUNTTYPE);
    }
  }, [accountSelect, handlerRequestDetail, mapDataDefault]);

  React.useEffect(() => {
    if (accountDetailStore && accountDetailStore.ACCOUNTNO === getValues("accountSource")) {
      mapDataDetail(accountDetailStore);
    }
  }, [accountDetailStore, getValues, mapDataDetail, t]);

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("ACC_CHI_TIET_TAI_KHOAN")} subtitles={subtitlesArrays} />
        <Block ph={isDesktop ? spacing.galactic : spacing.huge}>
          <Block row={isDesktop ? true : false} pt={spacing.medium}>
            {FieldForm()}
            {FormSelectAccount}
          </Block>
          <Block row={isDesktop ? true : false} pt={spacing.medium}>
            <Block>
              <StackSpacing size="medium" />
              <Paragraph style={styles.fieldFromText}>{t("COMMON_THONG_TIN_TAI_KHOAN")}</Paragraph>
              <StackSpacing size="medium" />
            </Block>
            {FormDetail}
          </Block>
          {ButtonForm}
        </Block>
        <GlobalModal ref={globalModalRef} />
      </ScrollView>
    </Block>
  );
};

export default DetailAccountRoll;
